var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-layout" }, [
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
      },
      [
        _c("div", { staticClass: "custom-toolbar" }, [
          _c(
            "div",
            { staticClass: "custom-toolbar-start" },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "Billing Profile",
                    },
                  },
                },
                [_c("h3", { staticClass: "title" }, [_vm._v("Billing")])]
              ),
              _c("h3", { staticClass: "title" }, [
                _vm._v("   >    " + _vm._s(_vm.$t("menus.billing.profile"))),
              ]),
            ],
            1
          ),
        ]),
      ]
    ),
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
      },
      [
        _c(
          "md-card",
          [
            _c(
              "md-card-header",
              { staticClass: "md-card-header-icon md-card-header-blue" },
              [
                _c(
                  "div",
                  { staticClass: "card-icon" },
                  [_c("md-icon", [_vm._v("payment")])],
                  1
                ),
              ]
            ),
            _c("md-card-content", [
              _c("div", { staticClass: "cf-container" }, [
                _c("h4", [
                  _vm._v(
                    "\n                        Manage your Locate2u Subscription\n                    "
                  ),
                ]),
                _c(
                  "p",
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.subTitleMessageEnt) +
                        "\n                        "
                    ),
                    _c("MailToSupport"),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.subTitleMessageEntPart2) +
                        "\n                    "
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }